import { gql } from '@/__generated__';

export const shippingMethods = gql(/* GraphQL */ `
  query ShippingMethods {
    shippingMethods {
      id
      name
      country
      description
      fee
      paymentMethods {
        id
        name
        country
        description
        fee
      }
    }
  }
`);

export const paymentMethods = gql(/* GraphQL */ `
  query PaymentMethods {
    paymentMethods {
      id
      name
      country
      description
      fee
    }
  }
`);

export const updateShippingMethod = gql(/* GraphQL */ `
  mutation UpdateShippingMethod(
    $where: ShippingMethodWhereUniqueInput!
    $data: ShippingMethodUpdateInput!
  ) {
    updateShippingMethod(where: $where, data: $data) {
      id
      name
      country
      description
      fee
      paymentMethods {
        id
        name
        country
        description
        fee
      }
    }
  }
`);
